export const BUBBLE_DESIGN = ['standard', 'expanded_bubble'];
export const WIDGET_DESIGN = ['standard', 'flat'];
export const DARK_MODE = ['light', 'auto', 'dark'];
export const CALLING_NUDGES_LABEL = 'calling-nudge';
export const MISSED_CALLS_LABEL = 'missed-call';
